import React from "react";
import { Modal, Typography, Button, Divider, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

interface AcceptSubmissionModalProps {
  open: boolean;
  onClose: () => void;
  handleAccept: (submissionId: string) => void;
  submissionId: string | null;
}

// Bouton personnalisé avec la couleur désirée
const AcceptButton = styled(Button)({
  backgroundColor: "#E3B505",
  color: "#fff",
  "&:hover": {
    backgroundColor: "#C79A04",
  },
});

const AcceptSubmissionModal: React.FC<AcceptSubmissionModalProps> = ({
  open,
  onClose,
  handleAccept,
  submissionId,
}) => {
  const handleConfirm = () => {
    if (submissionId) {
      handleAccept(submissionId);
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose} sx={{ zIndex: 9999 }}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: "70%", md: "40%" },
          maxWidth: 500,
          borderRadius: 2,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: { xs: 3, sm: 4 },
        }}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
          Confirmer l'acceptation
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="body1" sx={{ mb: 3 }}>
          Êtes-vous sûr de vouloir accepter cette soumission ?
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "flex-end",
            gap: 2,
            mt: 3,
          }}
        >
          <Button
            variant="outlined"
            color="secondary"
            onClick={onClose}
            fullWidth={false}
            sx={{
              minWidth: { xs: "100%", sm: "auto" },
              order: { xs: 2, sm: 1 },
            }}
          >
            Annuler
          </Button>
          <AcceptButton
            variant="contained"
            onClick={handleConfirm}
            fullWidth={false}
            sx={{
              minWidth: { xs: "100%", sm: "auto" },
              order: { xs: 1, sm: 2 },
            }}
          >
            Accepter
          </AcceptButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default AcceptSubmissionModal;
